import
  React
from 'react';

import
  PropTypes
from 'prop-types';

import {
  ColorSvg,
  Text,
  VContainer
} from '@vodacom/web-common';

import {
  withScreenViewTagging
} from 'hocs';

import {
  CustomColors,
  Icons
} from 'constants';

import {
  SecondaryButton
} from 'components';

const SocialBundleScenarioCardUI= props => {

  // Split the original string by ': ' to separate the qualifier from the list
  const [ qualifier, list ] = props.message.split(': ');

  // Split the list by ' -or- ' to get individual items
  const items = list ? list.split(' -or- ') : [];

  // Generate a modified list with numbered items and bold '-or-' text
  const modifiedList = items.map((item, index) => (
    <React.Fragment key={index}>
      <div>{index + 1}. {item}</div>
      {index !== items.length - 1 && <b>-or-</b>}
    </React.Fragment>
  ));

  SocialBundleScenarioCardUI.pageName = props.pageName;

  SocialBundleScenarioCardUI.tagViewData = {
    ...props.tagViewData,
    page_event: props.pageEvent,
    page_section: props.pageSection
  };

  return (

    <VContainer
      margin={'33px 0px 0px'}
      height={'288px'}
      alignItems={'center'}>

        <ColorSvg
          src={ props.icon }
          color={ props.color }
          width={'73px'}
          height={'73px'}/>

        <Text
          lineHeight={'39px'}
          margin={'5px 0px 11px'}
          textAlign={'center'}
          fontSize={'26px'}
          fontWeight={'700'}>

          {props.title}
        </Text>

        <Text
          margin={ props.isSuccess ? '0px 26px 44px': '0px 42px 54px' }
          lineHeight={'16.41px'}
          textAlign={props.isSuccess ?'center' : 'left'}
          fontSize={'14px'}
          fontWeight={'400'}>

          {props.isSuccess ?

            props.message
          :
            <>
              {qualifier}:
              <Text  margin={'15px 0px 0px 15px'}>
                {modifiedList}
              </Text>

            </>

        }

        </Text>

        <SecondaryButton
          margin={'0px'}
          height={'40px'}
          textColor={ props.isSuccess ?  CustomColors.Grey9 : CustomColors.White}
          activeBackgroundColor={ props.isSuccess ?  CustomColors.White : CustomColors.Red1}
          activeBorderColor={ props.isSuccess ?  CustomColors.Grey9 : CustomColors.Red1 }
          onClick={props.onClick}
          text={ props.buttonText }/>

    </VContainer>

  );
};

SocialBundleScenarioCardUI.propTypes = {
  message: PropTypes.string,
  isSuccess: PropTypes.bool,
  icon: PropTypes.string,
  color: PropTypes.string,
  title: PropTypes.string,
  buttonText: PropTypes.string,
  pageSection: PropTypes.string,
  pageEvent: PropTypes.string,
  tagViewData: PropTypes.object,
  pageName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

SocialBundleScenarioCardUI.defaultProps = {
  message: '',
  icon: Icons.SuccessCircleOutline,
  color: CustomColors.Green5,
  title: 'Success',
  buttonText: 'Close',
  pageName: '',
  pageSection: '',
  pageEvent: 'view',
  tagViewData: {},
  onClick: () => {}
};

export const SocialBundleScenarioCard = withScreenViewTagging(SocialBundleScenarioCardUI);